import { PricingPrice, PricingPriceWrap } from '@components/Pricing/index';
import Button from '@components/UI/Button';
import Divider from '@components/UI/Divider';
import Icon from '@components/UI/Icon';
import { StartButton } from '@screens/Pricing/StartButton';
import RenderIf from '@utils/renderIf';

import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

const PricingOptionB = ({ children, pricePlan, currentPlan, className }) => {
    if (!currentPlan) {
        return
    }

    const originalPrice = pricePlan.price
    const discount = currentPlan.discount ? (1 - currentPlan.discount / 100) : 1
    const effectivePrice = parseFloat((parseFloat(pricePlan.price) * discount).toFixed(2))

    return (
        <div
            className={twMerge("flex flex-col w-full p-6 xl:px-3 py-5 bg-white flex-1", className)}
        >
            <div className="mx-3 h-[144px] shrink-0">
                <div className="text-lg text-neutral2-900 font-semibold">
                    {pricePlan.label}
                </div>
                <div className="text-sm text-neutral2-800 mt-[4px]">
                    {pricePlan.description}
                </div>

                <RenderIf
                    isTrue={pricePlan.label !== 'ENTERPRISE'}
                >
                    <PricingPriceWrap className="mt-[26px] py-0 mb-0 flex flex-col">
                        <PricingPrice
                            originalPrice={originalPrice}
                            price={effectivePrice}
                        />

                        <div className="text-sm text-neutral2-800">
                            {effectivePrice <= 0 ? 'Free forever' : 'per user/month'}
                        </div>
                    </PricingPriceWrap>
                </RenderIf>
                <RenderIf
                    isTrue={pricePlan.label === 'ENTERPRISE'}
                >
                    <PricingPriceWrap className="mt-[26px]">
                        <PricingPrice
                            price={'Custom\nQuote'}
                            enterprise
                        />
                    </PricingPriceWrap>
                </RenderIf>
            </div>

            <Divider className="mx-2 mt-6 mb-4 !border-neutral-250" />

            <div className={"flex flex-col mb-auto"}>
                {pricePlan.featuresTitle && (
                    <div className="font-semibold text-sm mx-[6px] mt-[2px] mb-[6px]">
                        {pricePlan.featuresTitle}
                    </div>
                )}

                <div>
                    {pricePlan.features.map((child, i) => (
                        <div key={i} className="flex items-start py-[6px] gap-2">
                            <Icon
                                color="#0FA771"
                                name="check-path"
                                size={16}
                                className="my-[2px] mx-[5px]"
                            />
                            <div className="text-sm text-neutral2-800">
                                {child}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="mt-4 mx-2">
                <StartButton
                    paymentPlan={currentPlan}
                    plan={pricePlan}
                />
            </div>

            {children}
        </div>
    );
};

PricingOptionB.displayName = 'Pricing__Option'

PricingOptionB.propTypes = {
    children: PropTypes.node,
    mods: PropTypes.object
}

export default PricingOptionB
